export default "__VITE_ASSET__6ed9f259__"